/* @flow weak */
import Label from 'components/Label.jsx';
import React from 'react';
import Select from 'components/Select.jsx';
import { Roles } from 'user/UserConstants';

class RoleSelector extends React.Component {
  static propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.string.isRequired,
  };

  roleChanged = (value) => {
    this.props.onChange(value);
  };

  render() {
    const options = [
      {
        label: 'Parent',
        value: Roles.parent,
      },
      {
        label: 'Student',
        value: Roles.student,
      },
      {
        label: 'Teacher',
        value: Roles.teacher,
      },
    ];

    return (
      <div>
        <Label htmlFor="" hidden>
          Role
        </Label>
        <Select
          options={options}
          placeholder="Select role"
          value={this.props.value || ''}
          onChange={this.roleChanged}
        />
      </div>
    );
  }
}

export default RoleSelector;



// WEBPACK FOOTER //
// ./src/chat/components/RoleSelector.jsx